import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyInfoFilterDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form", "filter"],
  setup(__props, { emit }) {

const props = __props

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const selectedAction = ref({
  label: translate("messages.loyaltyInfo.selectAction"),
  value: "",
});
const selectedRemark = ref({
  label: translate("messages.loyaltyInfo.selectRemark"),
  value: "",
});
const onFilter = () => {
  // emit("filter");
  emit("submit", 1);
  showSync.value = false;
};
const actions = ref([
  {
    label: translate("messages.loyaltyInfo.selectAction"),
    value: "",
  },
  {
    label: translate("messages.loyaltyInfo.pointEarn"),
    value: "POINT_EARN",
  },
  {
    label: translate("messages.loyaltyInfo.pointBurn"),
    value: "POINT_BURN",
  },
  {
    label: translate("messages.loyaltyInfo.pointExpire"),
    value: "POINT_EXPIRED",
  },
  {
    label: translate("messages.loyaltyInfo.pointEarnRefund"),
    value: "POINT_EARN_REFUND",
  },
  {
    label: translate("messages.loyaltyInfo.pointAdjust"),
    value: "POINT_ADJUST",
  },
]);

const remarks = ref([
  {
    label: translate("messages.loyaltyInfo.selectRemark"),
    value: "",
  },
  {
    label: translate("messages.loyaltyInfo.turnOver"),
    value: "TURN_OVER",
  },
  {
    label: translate("messages.loyaltyInfo.manualTopup"),
    value: "MANUAL_TOPUP",
  },
  {
    label: translate("messages.loyaltyInfo.deductRedeem"),
    value: "DEDUCT_POINT",
  },
  {
    label: translate("messages.loyaltyInfo.redeem"),
    value: "REDEEM",
  },
]);

const onActionSelected = (e: any) => {
  selectedAction.value = e;
  emit("update:form", { ...props.form, action: e });
};

const onRemarkSelected = (e: any) => {
  selectedRemark.value = e;
  emit("update:form", { ...props.form, remark: e });
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.loyaltyInfo.advanceFilter")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: actions.value,
                              modelValue: selectedAction.value,
                              onOnOptionSelected: onActionSelected
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: remarks.value,
                              modelValue: selectedRemark.value,
                              onOnOptionSelected: onRemarkSelected
                            }, null, 8, ["options", "modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (showSync.value = false)),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.loyaltyInfo.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onFilter())),
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.loyaltyInfo.filter")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})